import { api } from "../base";
import type { IBookDepthSymbolList } from "@pulse-ui/codegen-v2/generated_ts/market_data";

export type {
  IBookDepthSymbol,
  IBookDepthSymbolList,
} from "@pulse-ui/codegen-v2/generated_ts/market_data";

// Served by trading-ops-server GET /api/trading-ops/v1/book-depth-symbols, which discovers what
// the capture store actually holds rather than mirroring l2-snapshot-store's venue config.
const bookDepthSymbolsEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getBookDepthSymbols: build.query<IBookDepthSymbolList, void>({
      query: () => ({
        url: "/api/trading-ops/v1/book-depth-symbols",
      }),
    }),
  }),
});

export const {
  useGetBookDepthSymbolsQuery,
  useLazyGetBookDepthSymbolsQuery,
} = bookDepthSymbolsEndpoints;
